module.exports = __webpack_public_path__ + "static/media/w_w_hr_12.94d459b9.png";